import React from 'react';
import StepHeading from './StepHeading';
import { noAutofill } from '../noAutofill';

interface BuildCommercialStep1Props {
  userName: string;
  setUserName: (name: string) => void;
  onEnterPress: () => void;
  loading: boolean;
}

const BuildCommercialStep1: React.FC<BuildCommercialStep1Props> = ({
  userName,
  setUserName,
  onEnterPress,
  loading,
}) => (
  <div className="ed-enter">
    <StepHeading
      index={1}
      kicker="Commercial Studio"
      title="Ten seconds. One idea."
      accent="Shot properly."
      lede="Cast it, write it, time it beat by beat, and let Omni shoot a full ten-second spot. First, the credit — who is directing?"
    />

    <div className="ed-block ed-block--sheet">
      <label className="ed-label" htmlFor="director-name">
        Directed by
      </label>
      <input
        id="director-name"
        type="text"
        className="ed-input ed-input--display"
        value={userName}
        onChange={(e) => setUserName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && userName.trim() && !loading) onEnterPress();
        }}
        placeholder="Type your name"
        {...noAutofill}
      />
      <p className="ed-hint">Press Enter to start production.</p>
    </div>
  </div>
);

export default BuildCommercialStep1;
